import script from "./BadgesTextArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./BadgesTextArea.vue?vue&type=script&lang=ts&setup=true"

import "./BadgesTextArea.vue?vue&type=style&index=0&id=541bec40&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541bec40"]])

export default __exports__